// This funky setup is dictated by how we build React in webapp currently. See
// the khan/react-build repo.
module.exports = window.React.__internalReactDOM;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dom/index.js
 ** module id = 44
 ** module chunks = 0 2
 **/